



















































































































































import Vue, {PropType} from 'vue'
import MobileSectionMenu from '@/components/project/MobileSectionMenu.vue'
import ParticipateButton from "@/components/contest/ContestDetails/ParticipateButton.vue";
import {User} from "@/model/User";

export default Vue.extend({
  name: 'SubmenuPage',

  components: {
    ParticipateButton,
    MobileSectionMenu,
  },

  props: {
    content: {
      type: String,
    },
    shortContent: {
      type: String,
      default: '',
    },
    showContent: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object as PropType<User>,
    },
    participationIsActive: {
      type: Boolean
    },
    canUserParticipate: {
      type: Boolean
    },
    stickyHeaderOffset: {
      type: Number
    },
    endAt: {
      type: String,
    },
    tags: {
      type: Object,
    },
    isTournament: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.fetchDescription()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('scroll', this.handleScrollActiveHeader)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('scroll', this.handleScrollActiveHeader)
  },

  data: function () {
    return {
      headers: [] as HTMLHeadingElement[],
      headersRev: [] as HTMLHeadingElement[],
      activeHeader: -1,
      scrollY: 0,
      mobileSectionMenuTop: 9999,
      projectMenuWidth: 0,
      showContentProp: this.showContent,
      desktopMainAppBarHeight: 60,
      tagsExpanded: false,
    }
  },

  directives: {
    'custom-links-attr': {
      inserted: function (html) {
        const links = html.querySelectorAll('a')

        links.forEach((link) => {
          link.target = '_blank'
          link.rel = 'nofollow noopener noreferrer'

          return link
        })
      }
    }
  },

  methods: {
    fetchDescription: function () {
      this.$nextTick(() => {
        const description = this.$refs.description as HTMLElement
        const additionalSections = this.$refs.additionalSections as HTMLElement
        const additionalSectionsBefore = this.$refs
          .additionalSectionsBefore as HTMLElement
        this.headers = [
          ...additionalSectionsBefore.querySelectorAll('h2'),
          ...description.querySelectorAll('h2'),
          ...additionalSections.querySelectorAll('h2'),
        ]
        this.headersRev = [...this.headers].reverse()
        this.$emit('contentReady')
        this.activeHeader = -1
      })
    },

    getFixedOffset: function (): number {
      // for mobile
      if (this.$vuetify.breakpoint.smAndDown) {
        return (this.$refs.mobileSectionFixedMenuRef as HTMLElement).clientHeight
      }

      // for desktop
      return this.desktopMainAppBarHeight
    },

    gotoHeader: function (element: HTMLHeadingElement) {
      window.scroll(0, element.getBoundingClientRect().top + this.scrollY - this.getFixedOffset())
    },

    handleScroll: function (e: Event) {
      const menu = this.$refs.menu as HTMLElement

      if (!menu) {
        return
      }

      const projectMenuHeight = menu.offsetHeight
      const scrollTop = document.documentElement.scrollTop
      const desktopMainAppBarOffset = this.desktopMainAppBarHeight + 10
      const contentTop =
        (this.$refs.contentTop as HTMLElement).getBoundingClientRect().top +
        scrollTop -
        desktopMainAppBarOffset
      const contentBottom =
        (this.$refs.contentBottom as HTMLElement).getBoundingClientRect().top +
        scrollTop -
        desktopMainAppBarOffset

      this.projectMenuWidth = (this.$refs.menu as HTMLElement).clientWidth

      if (
        scrollTop > contentTop &&
        scrollTop < contentBottom - projectMenuHeight
      ) {
        menu.style.position = 'fixed'
        menu.style.top = desktopMainAppBarOffset + 'px'
        menu.style.width = this.projectMenuWidth + 'px'
      } else {
        menu.style.position = 'relative'
        menu.style.top =
          scrollTop > contentBottom - projectMenuHeight
            ? contentBottom - projectMenuHeight - contentTop + 'px'
            : '0px'
        menu.style.width = 'auto'
      }
    },

    handleScrollActiveHeader: function () {
      const fixedOffset = this.getFixedOffset() + 5 // add extra margin to scroll detect
      const scrollTop = document.documentElement.scrollTop
      this.scrollY = scrollTop

      if (this.$refs.mobileSectionMenuRef) {
        this.mobileSectionMenuTop =
          (
            this.$refs.mobileSectionMenuRef as HTMLElement
          ).getBoundingClientRect().top + scrollTop
      }

      this.activeHeader =
        this.headers.length -
        this.headersRev.findIndex(
          (section) =>
            scrollTop >=
            (section as HTMLElement).getBoundingClientRect().top +
            scrollTop -
            fixedOffset
        ) -
        1
    },

    showContentClick: function () {
      if (this.content === null) {
        this.$store.dispatch(
          'alert/warning',
          'Detailed description will be available after contest finish'
        )

        return
      }

      this.showContentProp = true
    },
  },

  watch: {
    showContentProp: function () {
      this.fetchDescription()
    },
  },
})
